

















/* eslint-disable camelcase */
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Notification_IssueClosedViewObject } from '@/types/apiServerContract';
import bugtrackerService from '../../bugtracker/bugtracker.service';

@Component
export default class NotificationTypeIssueClosed extends Vue {
    @Prop({ required: true, type: Object }) notification!: Notification_IssueClosedViewObject;

    get closedStatus() {
        return bugtrackerService.getStatus(this.notification.issueStatus);
    }

    get closedStatusColor() {
        return bugtrackerService.getStatusColor(this.notification.issueStatus);
    }
}
